import './index.js';
import SESV2 from 'aws-sdk/clients/sesv2';
import {
  config as AWSConfig,
  CognitoIdentityCredentials
} from 'aws-sdk/lib/core';

import getValue from './util/get-value.js'
import { kMaxLength } from 'buffer';

var RECEIVER = 'ocpuzzledpint@gmail.com';
var SENDER = 'ocpuzzledpint@gmail.com';

function submitToAPI(e) {
  e.preventDefault();
  
  var name = getValue("#contactName");
  var email = getValue("#contactEmail");
  var topic = getValue("#contactSubj");
  var message = getValue("#contactMessage");
  var data = {
     name,
     email,
     topic,
     message
   };

  if (!new RegExp(/[A-Za-z]{1}[A-Za-z]/).test(name)) {
    alert('Name can not less than 2 char');
  } else if (!new RegExp(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/).test(email)) {
    alert('Bad email. Bad');
  }

  AWSConfig.update({
    region: 'us-west-2',
    credentials: new CognitoIdentityCredentials({
      IdentityPoolId: 'us-west-2:c5af291a-edb8-468c-b931-88dfaf7afe70'
    })
  });

  AWSConfig.credentials.get((err) => {
    if (err) {
      throw err;
    }

    var params = {
      Content: { /* required */
        Simple: {
          Body: {
            Text: {
              Data: 'name: ' + name + '\nemail: ' + email + '\n\n' + message,
              Charset: 'UTF-8'
            }
          },
          Subject: {
            Data: 'Website Mail Form: ' + topic,
            Charset: 'UTF-8'
          }
        }
      },
      Destination: {
        ToAddresses: [
            RECEIVER
        ]
      },
      FromEmailAddress: SENDER,
      ReplyToAddresses: [
        'NOREPLY@puzzledpintoc.com'
      ]
    };
    new SESV2().sendEmail(params, function(err, data) {
      if (err) console.log(err, err.stack); // an error occurred
      else {
        alert("Success, we'll get back to you asap!")
        document.location.replace('./index.html')
      }
    });
  });
}

(function setupSubmitButton() {
  const submitButton = document.querySelector('#contactSubmitButton');

  submitButton.addEventListener('click', submitToAPI);
})();